import type {ProForm} from '../../types';

import {EditOutlined} from '@ant-design/icons';
import {IconButton} from '@ds/components';

import {PRO_DELIVERY_METHOD_LABELS} from '../../../constants';
import {formatProStartDate} from '../../utils';

type ProReviewProps = {
  form: ProForm;
  onPreviousStepClick: () => void;
};

const ProReview: React.FC<ProReviewProps> = ({form, onPreviousStepClick}) => {
  return (
    <section className="flex-1 pt-4">
      <p className="px-4 text-body-sm text-neutral-fg">
        جزئیات سرویس پرو خود را بررسی و در صورت صحیح بودن آن را تایید کنید.
      </p>
      <div>
        <div className="flex flex-col border-b border-gray-22 px-4 py-3">
          <span className="text-body-sm text-gray-34">نام سرویس</span>
          <span className="text-body-sm-emphasis text-neutral-fg">سرویس پرو</span>
        </div>
        {Object.entries(form.selectedPolygons).map(([type, count]) => (
          <div key={type} className="flex flex-col border-b border-gray-22 px-4 py-3">
            <span className="text-body-sm text-gray-34">{PRO_DELIVERY_METHOD_LABELS[type]}</span>
            <span className="text-body-sm-emphasis text-neutral-fg">تعداد: {String(count)} محدوده</span>
          </div>
        ))}
        <div className="flex items-center justify-between gap-3 px-4 py-3">
          <div className="flex min-w-0 flex-1 flex-col">
            <span className="text-body-sm text-gray-34">زمان شروع</span>
            <span className="text-body-sm-emphasis text-neutral-fg">
              {formatProStartDate(form.date.start)}
            </span>
          </div>
          <IconButton aria-label="ویرایش تاریخ شروع" size="md" onClick={onPreviousStepClick}>
            <EditOutlined aria-hidden />
          </IconButton>
        </div>
      </div>
    </section>
  );
};

export default ProReview;
